<template>
  <div>
    <vx-card title="Description">
        <p class="mb-5">Organize by Subject and Category</p>
        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <v-select :options="data.subject" v-model="selectedSubject" label="label" placeholder="Select Class Subject"  />
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <v-select :options="data.category" v-model="group.category" placeholder="Select Category"  />
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input class="w-full" v-model="group.title" placeholder="Lesson Title" />
          </div>
        </div>

        <br>

        <div v-show="selectedSubject">
          <p class="mb-5">Specify Classes taking this lesson</p>

          <div class="vx-row ml-0 mr-0" v-show="selectedSubject && selectedSubject.subj_id == key" v-for="(value, key) in data.classes" :key="key">
            <div class="vx-col sm:w-1/6 w-full mb-2" v-for="(val, ky) in value" :key="ky">
              <ul v-for="(v, k) in val" :key="k">
                <li>
                  <vs-checkbox :vs-value="v.class_id" v-model="group.class">{{ v.class }}</vs-checkbox>
                </li>
              </ul>
            </div>
          </div>
        </div>
    </vx-card>

    <!-- <br>
    <br>
    <vx-card title="Video">
        <p class="mb-5">Upload video. Videos should be of reduced sizes.</p>
        <vs-upload action="https://swfgdev.s3.eu-west-2.amazonaws.com/folder/test.jpg?Content-Type=jpeg&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAWKQJBFNTSJ3BDJPB%2F20200422%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20200422T124301Z&X-Amz-Expires=7200&X-Amz-Signature=22c5d86e4906ff591ba91e203b9862de28d283920be0aa31f45eec43b6c5d652&X-Amz-SignedHeaders=host" @on-success="successUpload" />
    </vx-card> -->
    <br>
    <br>
    <vx-card title="Lesson Content" code-toggler>
        <p class="mb-5">Upload lecture content.</p>
        <quill-editor v-model="group.content"></quill-editor>

        <template slot="codeContainer">{{ group.content }}</template>

        <br>
        <br>

        <div class="vx-col w-full">
          <vs-button class="mr-3 mb-2" @click="addLesson">Submit</vs-button>
        </div>
    </vx-card>
  </div>
</template>

<script>
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import vSelect from 'vue-select'

import { quillEditor } from 'vue-quill-editor'
import Prism from 'vue-prism-component'

export default {
  data () {
    return {
      selectedSubject: null,
      group: {
        class: [],
        category: null,
        title:null,
        content: null
      },
      data: {
        subject: [],
        classes: {},
        category: []
      }
    }
  },
  components: {
    quillEditor,
    Prism,
    vSelect
  },
  created () {
    this.$http.get('/lms/st/academics/subject/assigned').then((response) => {
      if (response && response.data && response.data.data) {
        const tracker = { subj: {}, class: {} }

        response.data.data.forEach((v) => {
          if (!tracker.subj[v.subj_id]) {
            this.data.subject.push({ subj_id: v.subj_id, class_id: v.class_id, subj: v.subj_short, class: v.class_short, label: `${v.name}` })
          }

          if (!tracker.class[`${v.class_id}-${v.subj_id}`]) {
            this.data.classes[v.subj_id] = this.data.classes[v.subj_id] || {}
            const rank = v.rank.toString().slice(0, 2)
            this.data.classes[v.subj_id][rank] = this.data.classes[v.subj_id][rank] || []
            this.data.classes[v.subj_id][rank].push({ class: v.class_name, subj: v.subj_id, class_id: v.class_id })
          }

          tracker.class[v.class_id] = 1
          tracker.subj[v.subj_id] = 1
        })
      }
    }).catch((error) => { 
      console.log(error)
    })

    this.$http.get('/lms/st/lesson/category').then((response) => {
      if (response && response.data && response.data.data) {
        response.data.data.forEach((v) => {
          this.data.category.push({ id: v.id, label: v.name })
        })
      }
    }).catch((error) => { 
      console.log(error)
    })
  },
  watch: {
    selectedSubject: function (newValue, oldValue) {
      this.group.class = [];
    }
  },
  methods: {
    addLesson () {
      // if (this.group.content && this.group.content.length < 100) {
      //   return this.$vs.notify({ color: 'danger', title: 'Too Little Content', text: 'Add more text to the Lesson.' })
      // }

      if (this.selectedSubject && this.group.class.length && this.group.category && this.group.title && this.group.content) {
        const payload = {
          title: this.group.title,
          class: this.group.class,
          subj_id: this.selectedSubject.subj_id,
          category: this.group.category.id,
          text: this.group.content,
          slug: `${this.selectedSubject.subj}`
        }

        this.$vs.loading()
        this.$http.post('/lms/st/lesson', payload).then((response) => {
          this.$vs.loading.close()
          if (response && response.data && response.data.data) {
            this.$vs.notify({ color: 'success', title: 'Upload Success', text: 'Lesson uploaded' })
            this.$router.push('/lesson/personal')
          }
        }).catch((error) => { 
          this.$vs.loading.close()
          console.log(error)
        })
      } else {
        return this.$vs.notify({ color: 'danger', title: 'Incomplete Lesson', text: 'Fill all fields for this Lesson' })
      }
    },
    successUpload () {
      this.$vs.notify({ color: 'success', title: 'Upload Success', text: '' })
    }
  }
}
</script>
